$(document).ready(function() {
  // CTAs
  const configureBundleBtn = $('button[data-configure-bundle-btn]');
  const exitConfigureBundleBtn = $('[data-exit-configure-bundle-btn]');

  // page components
  const infoBarSection = $('#shopify-section-info-bar');
  const productSection = $('#section--product-page');
  const footerSection = $('#shopify-section-footer');

  const bundleProductSection = $('#section--product-page__bundle');
  const bundleAddToCartBanner = $('#component--add-to-cart--bundle');

  
  configureBundleBtn.click(function() {
    infoBarSection.fadeOut();
    productSection.fadeOut();
    footerSection.fadeOut();

    bundleProductSection.fadeIn();
    bundleAddToCartBanner.addClass('is-active');
    configureBundleImageCarousel();
    getSubtotal();
  });

  exitConfigureBundleBtn.click(function() {
    bundleProductSection.fadeOut();
    bundleAddToCartBanner.removeClass('is-active');

    infoBarSection.fadeIn();
    productSection.fadeIn();
    footerSection.fadeIn();
  });
  
});


function configureBundleImageCarousel() {
  $('[data-bundle-product-images-carousel]').each(function() {
    var id = $(this).data('bundle-item-id'); 
    const bundleImagesNav = $('[data-bundle-product-images-nav][data-bundle-item-id="' + id +'"]');
    const bundleImagesCarousel = $('[data-bundle-product-images-carousel][data-bundle-item-id="' + id +'"]');

    $(this).flickity({
      prevNextButtons: false
    })

    $(bundleImagesNav).flickity({
      asNavFor: bundleImagesCarousel,
      contain: true,
      pageDots: false,
      groupCells: true
    });

    $(bundleImagesNav).on('click', '.product__media-item', function() {
      var index = $(this).index();
      $(bundleImagesCarousel).flickity('select', index);
    })

    $('.description__bundle-variants-wrapper').on( 'click', '[data-bundle-item-variant][data-bundle-item-id="' + id +'"]', function() {
      var index = $(this).index();
      $(bundleImagesCarousel).flickity( 'selectCell', index );
      $(bundleImagesNav).flickity( 'selectCell', index );
    });
    
  });
}

function selectBundleVariant(item) {
  if (!$(item).hasClass('is-selected')) {
    var id = $(item).data('bundle-item-id');
    var sku = $(item).data('bundle-item-variant-sku');
    var title = $(item).data('bundle-item-variant-title');
    const bundleItem = $('[data-bundle-item][data-bundle-item-id="' + id + '"]');

    $(bundleItem).find('[data-bundle-item-variant]').each(function() {
      $(this).removeClass('is-selected');
    })
    $(item).addClass('is-selected');

    $(bundleItem).find('.description__sku').text('SKU #' + sku);
    $(bundleItem).find('.description__variant-title').text(title);

    getSubtotal();
  }
}


function getSubtotal() {
  subtotal = $('[data-bundle-item-variant].is-selected').map(function() {
    return $(this).data('bundle-item-variant-price');
  }).toArray().reduce((a, b) => a + b, 0);

  $('span[data-bundle-product-subtotal]').html('$' + (subtotal/100).toFixed(2));
}